// components/portal/tableChromeContext.ts
//
// WHO OWNS THE NAVIGATION BANNER ABOVE A LIST.
//
// Table and Grid each render their own ledger header (back arrow + breadcrumb + title). That is
// right when the list IS the surface, and wrong when the host already draws its own navigation:
// the admin table browser stacked two back arrows that did different things.
//
// A host that owns navigation says so once, around whatever it renders, instead of every list
// wrapper (twelve of them) growing a pass-through prop for the same one bit.
import { createContext } from 'react';

export const HostOwnsListNavigationContext = createContext(false);

// WHO OWNS OPENING A ROW.
//
// A row click normally means "focus this entity in the app": kernel.focusEntityUI, a session
// subject, whatever surface the Portal decides to paint. The admin database browser is not the
// app - it browses rows, and Property has no page to focus at all since the asset page was
// deleted, so its rows were simply inert.
//
// A host that wants the raw record instead says so once, around whatever it renders, and Table
// routes every row click there rather than into the focus system.
export const HostRowOpenContext = createContext<((entityType: string, id: string) => void) | null>(null);
